<template>
  <div class="action-type-container">
    <div class="col">
      <IconUpdate v-if="company.actionType === 13" :class="setClass(company.actionType)" class="icon" />
      <IconInactive v-if="company.actionType === 14" :class="setClass(company.actionType)" class="icon" />
      <IconArchive v-if="company.actionType === 11" :class="setClass(company.actionType)" class="icon" />
      <IconRejected v-if="company.actionType === 6" :class="setClass(company.actionType)" class="icon" />
      <IconTraitement v-if="company.actionType === 10" :class="setClass(company.actionType)" class="icon" />
      <IconAdd v-if="company.actionType === 12" :class="setClass(company.actionType)" class="icon" />
    </div>
    <div class="col" :style="config.style">
      <div class="title" :class="setClass(company.actionType)">{{ company.total }} {{ getTitle(company.actionType) }}</div>
      <div v-if="company.actionType < 10 && !isManual" class="description">
        ( {{ $t(`actionTypes._${company.actionType}`) }} <br v-if="!stylesTypes.includes(config.style)" />
        {{ company.errorMessage ? company.errorMessage : '' }})
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    company: {
      type: Object,
      required: true,
    },

    isManual: {
      type: Boolean,
      default: () => false,
    },

    config: {
      type: Object,
      required: false,
      default: () => ({ style: '', showWording: true }),
    },
  },

  data() {
    return {
      stylesTypes: ['filter'],
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },

  methods: {
    getTitle(type) {
      if (!this.config.showWording) return '';
      if (type < 10) {
        return this.$t(`actionTypes._6`);
      } else {
        return this.$t(`actionTypes._${type}`);
      }
    },

    setClass(type) {
      if (type < 10) {
        return 'red';
      } else if (type === 11 || type === 10 || type === 14) {
        return 'grey';
      } else if (type === 12) {
        return 'green';
      } else if (type === 13) {
        return 'blue';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.action-type-container {
  display: flex;

  .col {
    min-width: 24px;

    .icon,
    .title {
      &.red {
        color: colors.$red-color;
      }

      &.green {
        color: colors.$lightgreen-color;
      }

      &.grey {
        color: colors.$lightgrey-color;
      }

      &.blue {
        color: colors.$lightblue-color;
      }
    }

    .icon {
      width: 14px;
      height: 14px;
    }

    .title {
      font-weight: 500;
      font-size: 13px;
    }

    .description {
      color: colors.$lightgrey-color;
      margin: 4px 0 0;
    }
  }
}
</style>
